import { z } from 'zod';

export const SchemaTypeSchema = z.enum(['geneva', 'gwi']);
export type SchemaType = z.infer<typeof SchemaTypeSchema>;

export const schemaTypeOptions: Array<{ value: SchemaType; label: string }> = [
  { value: 'geneva', label: 'Geneva' },
  { value: 'gwi', label: 'World Investor' },
];
